import * as Actions from '../actions/category.actions';

const initialState = {
	allCategories: null,
};

export const categoryReducer = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case Actions.GET_ALL_CATEGORIES:
			return (state = {
				...state,
				allCategories: payload,
			});
		default:
			return state;
	}
};
